

























































































import { Component, Vue } from "vue-property-decorator";
import ChatBotService from "../services/chatbot";
import urlRegex from "url-regex";

const chatBotService = new ChatBotService();

@Component
export default class ChatBot extends Vue {
  loading = false;
  question = "";

  mounted() {
    this.$store.dispatch("setPopularQuestions", [
      "How do I register for SELFIE?",
      "How do I login?",
      "How do I navigate within SELFIE?",
      "How do I set SELFIE up for my school?",
      "How do I choose who will take part in SELFIE?"
    ]);
    this.addToConversation("chatbot", "Hello! How can I help you?");
  }

  public get conversation(): Array<{ type: string; text: string }>[] {
    return this.$store.state.conversation;
  }

  public get popularQuestions(): Array<string>[] {
    return this.$store.state.popularQuestions;
  }

  private get questionElement(): HTMLElement {
    return this.$refs.question as HTMLElement;
  }

  private addToConversation(type: string, text: string): void {
    this.$store.dispatch("addToConversation", {
      type: type,
      text: text,
      timestamp: new Date()
    });
  }

  onSubmitQuestion(evt: Event): void {
    evt.preventDefault();

    if (this.question.trim().length <= 0) {
      return;
    }

    this.askQuestion(this.question.trim()).then(() => {
      this.question = "";
    });
  }

  onAskPopularQuestion(question: string): void {
    if (!this.loading) {
      this.askQuestion(question);
    }
  }

  askQuestion(question: string): Promise<void> {
    this.loading = true;

    this.addToConversation("user", question);

    return chatBotService
      .getAnswer(question)
      .then(response => {
        this.loading = false;
        const answer = this.extractChatBotAnswer(response.data);

        this.addToConversation(
          "chatbot",
          answer
            ? answer
            : "I’m not able to find an answer to your question. Would you like to suggest this question to my database?"
        );
      })
      .catch(error => {
        this.loading = false;
        window.console.error(error);
        this.$bvToast.toast(error.message, {
          title: "Error!",
          variant: "danger"
        });
      })
      .then(() => {
        Vue.nextTick(() => {
          this.questionElement.scrollIntoView(false);
        });
      });
  }

  extractChatBotAnswer(responses: [string, string, number][]): string | null {
    if (!(responses.length > 0)) return null;

    if (responses.length === 1) return responses[0][1];

    return responses.sort((a, b) => {
      return b[2] - a[2];
    })[0][1];
  }

  onMoreQuestions(): void {
    this.$bvToast.toast("This feature has not been implemented yet!", {
      title: "NB!",
      variant: "warning"
    });
  }

  htmlifyText(value: string): string {
    let processed = value;
    processed = processed.replace(/\\n/g, "<br>");
    processed = processed.replace(urlRegex(), url => {
      return `<a href="${url}" target="_blank">${url}</a>`;
    });

    return processed;
  }
}
